import _ from 'lodash'
//import { fontFamily } from 'assets/themes/theme-default'

export const hydratorMethods = {
  HYDRATE_VEHICLE: 'hydrate_vehicle',
  HYDRATE_FILTERS: 'hydrate_filters',
  HYDRATE_POINTOFSALES: 'hydrate_point_of_sales',
  HYDRATE_POINTOFSALES_FROM_CAR: 'hydrate_point_of_sales_from-car',
  HYDRATE_CAMPAIGN: 'hydrate_campaign',
  HYDRATE_VEHICULE_FROM_CONFIGUARTOR: 'hydrate_vehicle_from_configurator'
}

export const hydratorOrigins = {
  ORIGIN_LIST: 1,
  ORIGIN_DETAIL: 2
}
/*
const pointOfSalesInit = {
  id: 256066,
  name: 'Point de vente Test 13',
  adress1: 'Avenue Gabriel Vicin',
  adress2: 'adress2',
  adress3: 'adress3',
  zipCode: '71100',
  city: 'Tournus',
  email: 'audrey.villien@bee2link.fr',
  phone1: '0630201025',
  phone2: '0385632010',
  lat: 46.5635561,
  lng: 4.8941945,
  entityName: 'entityName 1',
  DPOName1: 'Entite 1',
  DPOName2: 'GK',
  DPOEmail: 'guillaume.kick@beelink.fr'
}
*/
class Hydrator {
  static hydrateCampaign = datas => {
    const {
      id,
      name,
      beginDate,
      endDate,
      pointOfSalePositionSelection,
      deactivatedMakes,
      groupCampaign,
      deactivatedPointOfSalesIds,
      automaticValidation,
      header,
      styleSheetPath,
      footer,
      font,
      privacyPolicyUrl,
      cookiesConfiguration,
      maximumConnections,
      googleAnalyticsId,
      phoneRequired,
      themeColor1,
      themeColor2,
      faviconUrl,
      lang,
      idReferential,
      uid
    } = datas
    /*
        const header = {
          header: {
            html: `
            <style type="text/css">
            .ant-layout-header {
              height: 75px;
              z-index: 6;
              position: fixed;
              right: 0px;
              left: 0px;
              padding: 0px 100px;
              line-height: initial;
            }
            #header-porsche .m-00-header-lined-crest {
              margin-left: 1%;
              float: left;
              width: 99%;
              text-align: center;
              position: relative;
              z-index: 1;
              margin: 0;
              line-height: 0;
              display: inline-block;
              vertical-align: top;
              min-height: 1px;
            }
            html[dir="ltr"] #header-porsche .m-00-header-lined-crest:before {
              right: 0;
            }
            #header-porsche .m-00-header-lined-crest:before {
              content: '';
              border-bottom: 1px solid #e3e4e4;
              font-size: 0;
              position: absolute;
              bottom: 2px;
              right: 0;
              left: 2px;
              height: 1px;
              overflow: hidden;
              z-index: -1;
            }
            #header-porsche .m-00-crest-wrapper-svg {
              padding-left: 8px;
              padding-right: 8px;
              display: inline-block;
              background-color: #fff;
            }
            #header-porsche .m-00-crest-svg {
              background-image: url(https://media.openflex-preprod.eu/themes/porsche/porsche-svg.svg) !important;
              display: inline-block;
              outline: none;
              background-color: #fff;
              background-repeat: no-repeat;
              width: 123px;
              height: 75px;
              background-size: 123px auto;
              transform: translate3d(0,13px,0);
            }
            </style>
            <div id="header-porsche">
              <div class="m-00-header-lined-crest">
                <span class="m-00-crest-wrapper-svg">
                  <a class="m-00-crest-svg" href="https://www.porsche.com/" title="Porsche France"></a>
                </span>
              </div>
            </div>
      `,
            background: '#FFFFFF',
            border: 'transparent',
            height: 90
    
          },
          footer: {
            background: '#FFFFFF',
            border: '#e3e4e4',
          }
        }
    
          ;
    */
    const theme =
      themeColor1 && themeColor2
        ? {
            header: header && JSON.parse(header),
            faviconUrl,
            cookiesConfiguration: cookiesConfiguration && JSON.parse(cookiesConfiguration),
            styleSheetPath,
            footer,
            name,
            fontFamily: font && JSON.parse(font),
            colors: {
              color1: {
                bg: `#${themeColor1}`
              },
              color2: {
                bg: `#${themeColor2}`
              }
            }
          }
        : null

    const campaign = {
      id,
      name,
      beginDate,
      endDate,
      tradeInConfig: pointOfSalePositionSelection,
      deactivatedMakes,
      groupCampaign,
      deactivatedPointOfSalesIds,
      automaticValidation,
      maximumConnections,
      googleAnalyticsId,
      privacyPolicyUrl,
      phoneRequired,
      theme,
      lang,
      idReferential,
      uid
    }

    return campaign
  }

  static hydrateVehicle = datas => {
    const {
      id,
      makeId,
      make,
      modelId,
      model,
      trim,
      trimline,
      doors,
      version,
      putIntoService,
      co2Emission,
      mixedConsumption,
      gears,
      driveType,
      inclVatPrice,
      exclVatPrice,
      tax,
      beginPrice,
      genericType,
      configuration,
      pointOfSales,
      genericBody,
      horsepower,
      taxHorsepower,
      kilowatt,
      numberplate,
      modelCatalogBegin,
      module,
      externalColorWording,
      internalColorWording,
      picture,
      registration,
      chassis,
      catalog,
      colors,
      options,
      historical,
      mileage,
      equipments,
      painting,
      damages,
      tiresStateBack,
      tiresStateFront,
      secondTiresStateBack,
      secondTiresStateFront,
      secondTyres,
      tyresType,
      pictures,
      trailerHitch,
      curbWeight,
      genericFuel,
      genericFuelId,
      genericTransmissionType
    } = datas

    /*eslint-enable */
    const vehicle = {
      wsDatas: datas,
      configuration,
      module,
      id,
      version,
      make,
      makeId,
      model,
      modelId,
      trim: trim || trimline,
      energy: genericFuel,
      energyId: genericFuelId,
      co2Emission,
      doors,
      equipments: equipments || [],
      painting,
      gearBoxType: genericTransmissionType,
      horsePower: horsepower,
      taxPower: taxHorsepower,
      kilowatt,
      dateOfRegistration: putIntoService,
      urlImage: picture,
      driveType,
      NumberOfReports: gears,
      consumption: {
        mixed: mixedConsumption
      },
      inclVatPrice,
      exclVatPrice,
      tax,
      beginPrice,
      colors: {
        exterior: null,
        interior: null,
        ...colors
      },
      typeVehicle: genericType,
      pointOfSales,
      body: genericBody,
      numberplate,
      registration,
      chassis,
      modelCatalogBegin,
      externalColorWording,
      internalColorWording,
      catalog,
      options,
      historical,
      mileage,
      damages,
      tiresStateBack,
      tiresStateFront,
      secondTiresStateBack,
      secondTiresStateFront,
      secondTyres,
      tyresType,
      pictures,
      trailerHitch,
      curbWeight
    }

    return vehicle
  }

  static hydrateVehicleFromConfigurator = datas => {
    const {
      brand,
      model,
      price,
      funding,
      urlImage,
      finishes,
      motor,
      design,
      options,
      serviceContracts,
      curbWeight
    } = datas

    const { exterior, interior } = design // interior
    const { type } = exterior
    const arrayOfType = type ? [type] : []
    const totalOptionsPrice = _.sumBy(options, item => item.inclVatPrice)
    const totalServiceContractsPrice = _.sumBy(serviceContracts, item => item.price)
    const totalPaintPrice = _.sumBy(arrayOfType, item => item.price)
    const totalSaddleries = _.sumBy(interior, item => item.price)

    const vehicle = {
      make: brand.name,
      version: (motor && motor.title) || model.name,
      finishes: finishes && finishes.title,
      price,
      funding,
      urlImage,
      colors: {
        exterior: {
          wording: exterior && exterior.color && exterior.color.label,
          type: exterior && exterior.type && exterior.type.label,
          price: exterior && exterior.type && exterior.type.price
        },
        interior: { wording: interior && interior.color && interior.color.label }
      },
      options,
      serviceContracts,
      prices: {
        totalOptionsPrice,
        totalServiceContractsPrice,
        totalPaintPrice,
        totalSaddleries
      },
      curbWeight
    }

    return vehicle
  }

  static hydrateFilters = datas => {
    /*eslint-disable */
    const { s_veh_makname, s_veh_typtxtbodyco1cd2lbl } = datas
    /*eslint-enable */

    const filtersList = {
      brandsList: Object.values(s_veh_makname)
      // bodiesList: Object.values(s_veh_typtxtbodyco1cd2lbl)
    }
    return filtersList
  }

  static hydratePointOfSales = datas => {
    /*eslint-disable */
    const {
      gen_s_cli_id,
      iId,
      sLibelle,
      sAdresse1,
      sAdresse2,
      sAdresseAdd1,
      sAdresseAdd2,
      sCP,
      sVille,
      sEmail,
      sTelephone,
      fGpsLatitude,
      fGpsLongitude,
      sCode,
      iMarqueId
    } = datas
    /*eslint-enable */

    const pointOfSales = {
      apiKey: gen_s_cli_id,
      id: iId,
      distributorCode: sCode,
      mainBrand: Number(iMarqueId),
      name: sLibelle,
      adress1: sAdresse1,
      adress2: sAdresse2,
      adress3: sAdresseAdd1,
      adress4: sAdresseAdd2,
      zipCode: sCP,
      city: sVille,
      email: sEmail,
      phone1: sTelephone,
      //phone2: PropTypes.string,
      lat: Number(fGpsLatitude),
      lng: Number(fGpsLongitude)
    }

    return pointOfSales
  }

  static hydratePointOfSalesFromWS = datas => {
    const { entity, pointOfSale } = datas
    const pointOfSales = {
      ...pointOfSale,
      entity: entity && entity.value
    }

    return pointOfSales
  }

  /**
   * Envoi POST d'une requête vers l'API
   *
   * @param {string} method le nom de la méthode définie dans le tableau de méthodes ci-dessus
   * @param {*} datas un objet de données à envoyer dans la méthode
   * @static
   * @return {Promise} une promesse avec les données renvoyées par l'API
   */
  static hydrate = (method, datas, origin) => {
    if (method === hydratorMethods.HYDRATE_VEHICLE) {
      return Hydrator.hydrateVehicle(datas, origin)
    }

    if (method === hydratorMethods.HYDRATE_FILTERS) {
      return Hydrator.hydrateFilters(datas)
    }

    if (method === hydratorMethods.HYDRATE_POINTOFSALES) {
      return Hydrator.hydratePointOfSales(datas)
    }

    if (method === hydratorMethods.HYDRATE_POINTOFSALES_FROM_CAR) {
      return Hydrator.hydratePointOfSalesFromWS(datas)
    }

    if (method === hydratorMethods.HYDRATE_CAMPAIGN) {
      return Hydrator.hydrateCampaign(datas)
    }

    if (method === hydratorMethods.HYDRATE_VEHICULE_FROM_CONFIGUARTOR) {
      return Hydrator.hydrateVehicleFromConfigurator(datas)
    }

    return null
  }
}

export default Hydrator
